import { randomString } from '@/utils/tools';

/**
 * 生成用于上报去重的事件 ID。
 * 事件 ID 委托随机串工具生成，并在本函数边界强制收敛为 32 位，避免 fallback 长度漂移影响下游契约。
 * @returns 32 位无特殊字符事件 ID
 */
export function generateEventId(): string {
  return randomString(32).slice(0, 32);
}
